import React, { ReactNode } from 'react';
import cx from 'clsx';

import style from './index.module.css';

interface TagProps {
  className?: string;
  children?: ReactNode;
  color?: 'red' | 'green' | 'primary' | 'grayblue' | 'lightgray' | 'blue';
  rounded?: boolean;
  solid?: boolean;
  onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

// rest for components register dom event
export const Tag = ({ children, className, color, solid, rounded, ...rest }: TagProps) => {
  return (
    <span
      {...rest}
      className={cx(
        style.tag,
        color && style[`is_${color}`],
        solid && style.is_solid,
        rounded && style.is_rounded,
        rest?.onClick && style.is_clickable,
        className,
      )}>
      {children}
    </span>
  );
};
